/** Scam Shield client (§23) — message/link scanner, reports, verified entities. */
import { api } from './client';

export type Verdict = 'safe' | 'suspicious' | 'high_risk';

export interface ScanVerdict {
  verdict: Verdict;
  score: number;
  reasons: string[];
  advice: string;
}

export interface ScamScan {
  id: string;
  kind: 'message' | 'link';
  excerpt: string | null;
  verdict: Verdict;
  score: number;
  reasons: string[];
  created_at: string;
}

export interface ScamReport {
  id: string;
  reporter: string;
  platform: string | null;
  sender: string | null;
  link: string | null;
  note: string | null;
  risk_score: number;
  status: string;
  created_at: string;
}

export interface VerifiedEntity {
  id: string;
  name: string;
  category: string;
  domains: string[];
  phones: string[];
  sender_ids: string[];
  country: string;
}

export const scamApi = {
  scanMessage: (text: string, platform?: string) =>
    api<ScanVerdict>('/v1/scam/scan-message', { method: 'POST', body: { text, platform: platform ?? null } }),
  scanLink: (url: string) =>
    api<ScanVerdict>('/v1/scam/scan-link', { method: 'POST', body: { url } }),
  scans: () => api<ScamScan[]>('/v1/scam/scans'),
  report: (body: { platform?: string; sender?: string; link?: string; note?: string }) =>
    api<ScamReport>('/v1/scam/reports', { method: 'POST', body: { ...body, reporter: 'parent' } }),
  reports: () => api<ScamReport[]>('/v1/scam/reports'),
  verifiedEntities: () => api<VerifiedEntity[]>('/v1/scam/verified-entities'),
};
